<template>
<!-- Main content -->
<section class="content">

  <span v-if="!this.$store.getters.modules.includes('1.25')" class="">
      <a href="/"><img :src="$store.state.organisationLogo" alt="Logo" class="img-responsive center-block logo"></a>
    </span>

  <div class="p-field p-col-12 p-md-4" v-if="this.$store.getters.modules.includes('1.25')">
  <label for="fromDate" style="font-weight: bold;color: #1818c3cc">Daily Summary: </label>
<date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
<InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
</div>

  <div class="row" v-if="$store.state.organisationid != 7 && this.$store.getters.modules.includes('1.25')">
    <div class="col-md-3 col-sm-6 col-xs-12">
      <process-info-box class="purchase" color-class="bg-white" :icon-classes="['fa', 'fa fa-cart-arrow-down']" text="Purchase" :number="totalPurchase" :selectedGradient="['#3F5EBF']"></process-info-box>
    </div>
    <!-- /.col -->

    <!-- fix for small devices only -->
    <div class="clearfix visible-sm-block"></div>

    <div class="col-md-3 col-sm-6 col-xs-12">
      <!-- <img src="../../../static/img/sales.png"/> -->
      <process-info-box color-class="bg-white" :icon-classes="['fa', 'fa fa-shopping-bag']" text="Sales" :number="totalSales" :selectedGradient="['#42b3f4']">
      </process-info-box>
    </div>
    <!-- /.col -->

    <div class="col-md-3 col-sm-6 col-xs-12">
      <process-info-box class="purchase" color-class="bg-white" :icon-classes="['pi', 'pi pi-money-bill']" text="Cash Out" :number="totalCashOut" :selectedGradient="['red']"></process-info-box>
    </div>
    <div class="col-md-3 col-sm-6 col-xs-12">
      <process-info-box class="cashIn" color-class="bg-white" :icon-classes="['pi', 'pi pi-money-bill']" text="Cash In" :number="totalCashIn" :selectedGradient="['green']"></process-info-box>
    </div>
    <!-- /.col -->

  </div>
  <div class="p-field p-col-12 p-md-4" v-if="this.$store.getters.modules.includes('1.25')">
    <label for="fromDate" style="font-weight: bold;color: #1818c3cc">As of date: </label>
    <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
    <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
    </div>

    <div class="row" v-if="$store.state.organisationid != 7 && this.$store.getters.modules.includes('1.25')">
    <div class="col-md-3 col-sm-6 col-xs-12">
      <process-info-box class="purchase" color-class="bg-white" :icon-classes="['fa', 'fa fa-inr']" text="Account Payable" :number="totalAccountPayable" description="" :selectedGradient="['#8A64FB']"></process-info-box>
    </div>
    <div class="col-md-3 col-sm-6 col-xs-12">
      <process-info-box class="cashIn" color-class="bg-white" :icon-classes="['fa', 'fa fa-inr']" text="Account Receivable" :number="totalAccountReceivable" description="" :selectedGradient="['#70F7AD']"></process-info-box>
    </div>
    <div class="col-md-3 col-sm-6 col-xs-12">
      <process-info-box color-class="bg-white" :icon-classes="['fa', 'fa fa-inr']" text="Cash Balance" :number="totalCashInHand" description="" :selectedGradient="['#7CA1FD']"></process-info-box>
    </div>
    <div class="col-md-3 col-sm-6 col-xs-12">
      <process-info-box color-class="bg-white" :icon-classes="['fa', 'fa fa-university']" text="Bank Balance" :number="totalBankBalance" description="" :selectedGradient="['purple', 'violet']"></process-info-box>
    </div>
    </div>

    <div class="row" v-if="$store.state.organisationid != 7 && this.$store.getters.modules.includes('1.25')">
    <div class="col-md-4 col-sm-6 col-xs-12">
        <canvas id="planet-chart"></canvas>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-12">
        <canvas id="planet-chart2"></canvas>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-12">
        <canvas id="planet-chart7"></canvas>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-12">
        <canvas id="planet-chart4"></canvas>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-12">
        <canvas id="planet-chart3"></canvas>
      </div>
      
      <div class="col-md-4 col-sm-6 col-xs-12">
        <canvas id="planet-chart5"></canvas>
      </div>
      <div class="p-field p-col-12 p-md-2">
     <!-- <label type="text" style="color:blue" ref="name">{{ this.cashSales }}</label> -->
    </div>

  </div>

  
  <!-- /.row -->

  <!-- <div class="col-xs-12">
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title"></h3>
          <div class="box-body">
            <div class="col-sm-6 col-xs-12">
              <p class="text-center">
                <strong>Transaction Overview</strong>
              </p>
              <canvas id="trafficBar" ></canvas>
            </div>
            <hr class="visible-xs-block">
            <! <div class="col-sm-6 col-xs-12">
              <p class="text-center">
                <strong>Language Overview</strong>
              </p>
              <canvas id="languagePie"></canvas>
            </div> -->
  <!-- <div class="text-center">
          <small><b>Pro Tip</b> Don't forget to star us on github!</small>
        </div> -->
  <!-- /.row -->

  <!-- Main row -->



  
  <!-- <div v-if="$store.state.organisationid == 7 && $store.state.warehouseData.id == 0">
     <a  href="/"><img :src="$store.state.organisationLogo" alt="Logo" style="width: 50%;margin-bottom: -8%;" class="img-responsive center-block logo"></a>
  </div> -->
  <!-- <div v-if="$store.state.organisationid == 7 && $store.state.warehouseData.id != 0">
   
   <div class="clearfix visible-sm-block"></div>

    <div class="col-md-3 col-sm-6 col-xs-12">

      <process-info-box color-class="bg-white" :icon-classes="['fa', 'fa fa-check-square']" text="Delivered" :number="delivered">
      </process-info-box>
    </div>

    <div class="col-md-3 col-sm-6 col-xs-12">
    
      <process-info-box color-class="bg-white" :icon-classes="['fa', 'fa fa-check-square']" text="Delivered Amount" :number="deliveredAmount">
      </process-info-box>
    </div>
        <div class="col-md-3 col-sm-6 col-xs-12">
   
      <process-info-box color-class="bg-white" :icon-classes="['fa', 'fa fa-shopping-bag']" text="Delivery Charge Amount" :number="deliveredCharge">
      </process-info-box>
    </div>

  </div> -->
    <!-- <div v-if="$store.state.organisationid == 7 && $store.state.warehouseData.id != 0">
    
   <div class="clearfix visible-sm-block"></div>

    <div class="col-md-3 col-sm-6 col-xs-12">
      
      <process-info-box color-class="bg-white" :icon-classes="['fa', 'fa fa-truck']" text="Processing" :number="processing">
      </process-info-box>
    </div>

    <div class="col-md-3 col-sm-6 col-xs-12">
    
      <process-info-box color-class="bg-white" :icon-classes="['fa', 'fa fa-truck']" text="Processing Amount" :number="processingAmount">
      </process-info-box>
    </div>
        <div class="col-md-3 col-sm-6 col-xs-12">
    
      <process-info-box color-class="bg-white" :icon-classes="['fa', 'fa fa-stop']" text="Cancelled" :number="cancelled">
      </process-info-box>
    </div>

     <div class="col-md-3 col-sm-6 col-xs-12">
      
      <process-info-box color-class="bg-white" :icon-classes="['fa', 'fa fa-stop']" text="Cancelled Amount" :number="cancelledAmount">
      </process-info-box>
    </div>

      <div class="col-md-3 col-sm-6 col-xs-12">
    
      <process-info-box color-class="bg-white" :icon-classes="['fa', 'fa-step-backward']" text="Returned" :number="returned">
      </process-info-box>
    </div>
      <div class="col-md-3 col-sm-6 col-xs-12">
   
      <process-info-box color-class="bg-white" :icon-classes="['fa', 'fa-step-backward']" text="Returned Amount" :number="returnedOrdersAmount">
      </process-info-box>
    </div>
    <div class="col-md-3 col-sm-6 col-xs-12">
     
      <process-info-box color-class="bg-white" :icon-classes="['fa', 'fa-step-backward']" text="Receivable Amount" :number="payableAmount">
      </process-info-box>
    </div>
    <div class="col-md-3 col-sm-6 col-xs-12">
     
      <process-info-box color-class="bg-white" :icon-classes="['fa', 'fa-step-forward']" text="UnPaid Amount" :number="unPaidAmount">
      </process-info-box>
    </div>
  </div> -->

  <div  class="chartData" v-if="this.$store.getters.modules.includes('1.25')">
    <Chart type="line"/>
  </div>
</section>
<!-- /.content -->
</template>

<script>
import InfoBox from '../widgets/InfoBox'
import ProcessInfoBox from '../widgets/ProcessInfoBox'
import Chart from './Chart.vue'
import $ from 'jquery'
import DatePicker from 'vue2-datepicker'
import InputMask from 'primevue/inputmask'
import * as planetCharts from '../../chart'
export default {
  name: 'Dashboard',
  components: {
    InfoBox,
    DatePicker,
    ProcessInfoBox,
    Chart,
    InputMask,
    planetCharts
  },
  data() {
    return {
      totalSales: '',
      fromDate: null,
      toDate: null,
      totalPurchase: '',
      planetChartData: planetCharts.barChart,
      englishDateEnabled: true,
      totalCashIn: '',
      warehouseId: '',
      totalCashOut: '',
      totalAccountReceivable: '',
      totalAccountPayable: '',
      totalCashInHand: '',
      totalBankBalance: '',
      deliveredAmount: 0.0,
      delivered: 0,
      deliveredCharge: 0.0,
      cancelledAmount: 0.0,
      cancelled: 0,
      returnedOrdersAmount: 0.0,
      payableAmount: 0.0,
      unPaidAmount: 0.0,
      returned: 0,
      processingAmount: 0.0,
      processing: 0
    }
  },
  computed: {
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    }
  },
  mounted() {
    if (this.$store.state.organisationid !== 'undefined' && this.$store.state.organisationid !== undefined) {
      this.dailyTransactionSummary()
      this.dailyCashSummary()
      this.deliverySummary()
    }
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
  },
  methods: {
    async dailyTransactionSummary() {
      let response = await this.$store.dispatch('loadDailyTransactionSummary')
      response.data.data.forEach(data => {
        if (data.name === 'Total Purchase') {
          this.totalPurchase = data.balance.toString()
        } else if (data.name === 'Total Sales') {
          this.totalSales = data.balance.toString()
        } else if (data.name === 'Total Receipt') {
          this.totalCashIn = data.balance.toString()
        } else if (data.name === 'Total Payment') {
          this.totalCashOut = data.balance.toString()
        }
      })
    },
    async deliverySummary() {
      let dat = {
        warehouse: this.$store.state.warehouseData.id
      }
      let response = await this.$store.dispatch('loadDeliverySummary', dat)
      response.data.data.forEach(data => {
        if (data.name === 'Delivered Amount') {
          this.deliveredAmount = data.totalAmount
        } else if (data.name === 'Delivered') {
          this.delivered = data.totalCount
        } else if (data.name === 'UnPaid') {
          this.unPaidAmount = data.totalAmount.toString()
        } else if (data.name === 'Delivered Charge') {
          this.deliveredCharge = data.totalAmount.toString()
        } else if (data.name === 'Cancelled Amount') {
          this.cancelledAmount = data.totalAmount.toString()
        } else if (data.name === 'Cancelled') {
          this.cancelled = data.totalCount.toString()
        } else if (data.name === 'Returned Orders Amount') {
          this.returnedOrdersAmount = data.totalAmount.toString()
        } else if (data.name === 'Returned') {
          this.returned = data.totalCount.toString()
        } else if (data.name === 'Processing Amount') {
          this.processingAmount = data.totalAmount.toString()
        } else if (data.name === 'Processing') {
          this.processing = data.totalCount.toString()
        } else if (data.name === 'Payable Amount') {
          this.payableAmount = data.totalAmount.toString()
        }
      })
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    async dailyCashSummary() {
      let response = await this.$store.dispatch('loadDailyCashSummary')
      response.data.data.forEach(data => {
        if (data.name === 'Cash in hand') {
          this.totalCashInHand = data.balance.toString()
        } else if (data.name === 'Customer Balance') {
          this.totalAccountReceivable = data.balance.toString()
        } else if (data.name === 'Supplier Balance') {
          this.totalAccountPayable = data.balance.toString()
        } else if (data.name === 'Bank Balance') {
          this.totalBankBalance = data.balance.toString()
        }
      })
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  }
}
</script>
<style>
.info-box {
  cursor: pointer;
}

/* .info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
} */
.purchase{
  color:#090101;
}
.cashIn{
  color: #090101;
}
.fullCanvas {
  width: 100%;
}
.content-wrapper {
  background: transparent;
}
/* .content-wrapper .content {
  padding: 0 15px;
} */
</style>



// WEBPACK FOOTER //
// Dashboard.vue?7988ec40